"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs_js_1 = require("../configs/configs.js");
const Path_1 = require("../Util/Path");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
class DynamicQuestionnaireRepository {
    constructor(config, httpClient, questionnaireTransformer, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.questionnaireTransformer = questionnaireTransformer;
        this.errorTransformer = errorTransformer;
    }
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get('transformer.questionnaire_to_data'), container.get('transformer.axios_to_error'));
    }
    /**
     * @inheritDoc
     */
    get(id, valuation) {
        const url = Path_1.default.route(configs_js_1.configs.endpoints.dynamicQuestionnaire, {
            questionnaire: id,
            lang: this.config.getWidgetLang(),
            valuation: valuation.getToken(),
        });
        return this.httpClient.get(url)
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then(res => this.questionnaireTransformer.from(res.data));
    }
}
exports.default = DynamicQuestionnaireRepository;
Mixin_1.default(DynamicQuestionnaireRepository, IContainerInjection_1.default);
